export type AdminDashboardTab =
  | 'overview'
  | 'users'
  | 'subscriptions'
  | 'payments'
  | 'pricing'
  | 'demo-requests'
  | 'crisis-communications'
  | 'training'
  | 'tabletop'
  | 'templates'
  | 'bcps'
  | 'insurers'
  | 'security';

export const ADMIN_DASHBOARD_PATH = '/admin';

const VALID_TABS: AdminDashboardTab[] = [
  'overview',
  'users',
  'subscriptions',
  'payments',
  'pricing',
  'demo-requests',
  'crisis-communications',
  'training',
  'tabletop',
  'templates',
  'bcps',
  'insurers',
  'security',
];

export function adminDashboardTabItems(): {
  key: AdminDashboardTab;
  label: string;
}[] {
  return [
    { key: 'overview', label: 'Overview' },
    { key: 'users', label: 'Users' },
    { key: 'subscriptions', label: 'Subscriptions' },
    { key: 'payments', label: 'Payments' },
    { key: 'pricing', label: 'Pricing' },
    { key: 'demo-requests', label: 'Demo Leads' },
    { key: 'crisis-communications', label: 'Crises' },
    { key: 'training', label: 'Academy' },
    { key: 'tabletop', label: 'Tabletops' },
    { key: 'templates', label: 'Templates' },
    { key: 'bcps', label: 'BCPs' },
    { key: 'insurers', label: 'Insurers' },
    { key: 'security', label: 'Security' },
  ];
}

export function parseAdminDashboardTab(
  search: URLSearchParams
): AdminDashboardTab {
  const raw = search.get('tab');
  if (raw && VALID_TABS.includes(raw as AdminDashboardTab)) {
    return raw as AdminDashboardTab;
  }
  return 'overview';
}

export function adminDashboardTabHref(tab: AdminDashboardTab): string {
  if (tab === 'overview') {
    return ADMIN_DASHBOARD_PATH;
  }
  return `${ADMIN_DASHBOARD_PATH}?tab=${tab}`;
}

export function getAdminDashboardTabLabel(tab: AdminDashboardTab): string {
  if (tab === 'insurers') return 'Insurance';
  const match = adminDashboardTabItems().find((item) => item.key === tab);
  return match?.label ?? 'Overview';
}

export function isAdminDashboardArea(pathname: string): boolean {
  return pathname === ADMIN_DASHBOARD_PATH;
}
